/*
    Number of results shown per search results page
*/
export const RESULTS_PER_PAGE = 10;
